import { Autocomplete as MuiAutocomplete, styled, TextField as MuiTextField } from '@mui/material';
import type { Option } from './Autocomplete';

export const Wrapper = styled('div')(() => ({ width: '100%' }));

export const StyledAutocomplete = styled(MuiAutocomplete<Option | string, boolean, boolean, boolean>)(() => ({
  '&.MuiAutocomplete-root .MuiOutlinedInput-root': {
    padding: '2.5px 6px',
  },
  zIndex: 13000,
}));

export const StyledTextField = styled(MuiTextField)<{
  background?: 'transparent' | 'white';
  error?: boolean;
}>(({ theme, background = 'transparent', error }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: error ? theme.palette.error.light : background === 'transparent' ? 'transparent' : theme.palette.common.white,
  },
}));
